import $ from "jquery";

const handlePaginationClick = e => {
  const cardContentPath = Number(e.target.closest(".pagination-controls").data("card-content-path"));
  const page = Number(e.target.closest("li").data("target-page"));
  $(e.target.closest("[data-card-id]")).find(".card-body").load(`${cardContentPath}?page=${page}`);
};

// const handleSegmentAnalytics = e => {
//   // Segment analytics
//   var accordion_header = $(e.target.parentNode).find(".accordion-card-header");
//   if (!accordion_header) return;

//   var accordion_link = accordion_header.find("a")[0];
//   if (!accordion_link) return;

//   var pageTitle = $("span", "#page-title").html();
//   var cardContainer = $(e.target.closest("[data-card-id]"));
//   var cardTitle = cardContainer.find(".title-text").text();
//   var cardId = cardContainer.attr("data-card-id");

//   window.analytics.track("Accordion expanded", {

//     accordion_url: accordion_link.href,
//     accordion_title: $(accordion_link).text(),
//     card_title: cardTitle,
//     page_title: pageTitle,
//     card_id: cardId
//   });
// };

$(document).on("turbolinks:load", () => {
  if (!$(".cards").length) return;

  $(window).on("attachPaginationListener", () => {
    $(".pagination-controls li").on("click", handlePaginationClick);
  });

  $(".accordion").on("shown.bs.collapse", function (e) {
    // SI: when the charts start inside a collapsed accordion box, their width is calculated wrong and they slightly overflow it
    //  so when the accordion expands we want to force any charts inside it to reflow.
    var $container = $(e.target);
    var $highcharts = $container.find("[data-highcharts-chart]");

    $highcharts.each(function () {
      var highchart = $(this).highcharts();

      highchart.containerWidth = 0;
      highchart.reflow();
    });

    // handleSegmentAnalytics(e);
  });
});
